import { environment } from "../../config/environment";
import { customFetch } from "../../utils/Auth";
import { InsightEvent } from "./types";

export async function fetchInsightsByPatient(
  patientId: string
): Promise<{ data: InsightEvent[]; error?: string }> {
  try {
    const response = await customFetch(
      `${environment.apiUrl}/insights/fetch`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify({ patient_id: patientId }),
      }
    );

    if (!response.ok) {
      return {
        data: [],
        error: `Error: ${response.status} ${response.statusText}`,
      };
    }

    const data = await response.json();
    return { data: Array.isArray(data) ? data : [] };
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : "Failed to load insights";
    return { data: [], error: message };
  }
}
